import {DataTable} from '../ui/DataTable';
import {StatusBadge} from '../ui/StatusBadge';
import {Link} from '../ui/ScopedLink';
import {supplierRelationshipStatus} from '@myfm/domain';
import type {Supplier} from './SupplierSetup';
import './supplier-register.css';

export function SupplierRegisterTable({rows,suffix,pageSize=18}:{rows:Supplier[];suffix:string;pageSize?:number}){
 const setup=(row:Supplier)=>`/work/suppliers/${row.id}/setup${suffix?'?'+suffix:''}`;
 return <DataTable compact className="supplier-register-table" caption={<span className="sr-only">Supplier register</span>} scrollLabel="Suppliers" rows={rows} getRowKey={row=>row.id} pageSize={pageSize}
 rowHeader={{id:'supplier',header:'Supplier name',sortValue:row=>row.trading_name||row.legal_name,render:row=><Link className="supplier-register-link" to={setup(row)} title={row.legal_name}>{row.trading_name||row.legal_name}</Link>}}
 columns={[
  {id:'state',header:'Supplier status',sortValue:supplierRelationshipStatus,render:row=><StatusBadge tone="neutral" text={supplierRelationshipStatus(row)}/>},
  {id:'service',header:'Primary service',sortValue:row=>row.primary_service,render:row=>row.primary_service||'Not recorded'},
 ]}/>;
}
